import axiosInstance from "../interceptor/instance";

const baseUrl = process.env.REACT_APP_BASE_URL_WEB_MAP;

export const mapUploadFile = async (payload) => {
  const response = await axiosInstance.post(`${baseUrl}/upload/file`, payload, {
    hideLoader: true,
    headers: {
      "Content-Type": "multipart/form-data",
    }
  });
  return response.data;
};

export const getWebMapSettingFile = async () => {
  const response = await axiosInstance.get(
    `${baseUrl}/download/web-map-settings`
  );
  return response.data;
};

export const getWebMapLayers = async (collectionName, quarter) => {
  const response = await axiosInstance.get(
    `${baseUrl}/download/layers/${collectionName}/${quarter}`
  );
  return response.data;
};

export const getUploadedDataFromFile = async (id) => {
  const response = await axiosInstance.get(
    `${baseUrl}/upload/file/${id}`
  );
  return response.data;
};

export const getUploadedFiles = async (country, year, quarter) => {
  const response = await axiosInstance.get(
    `${baseUrl}/upload/files/${country}/${year}/${quarter}`
  );
  return response.data;
};

export const deleteUploadedFile = async (id) => {
  const response = await axiosInstance.delete(
    `${baseUrl}/upload/file/${id}`
  );
  return response.data;
};